// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3RLG2","notes":"Notes_notes__32F7M","note":"Notes_note__3x5sk","markdown":"Notes_markdown__28ULj"};